import type { PIPController, Props } from './PIPController'

let pipController: PIPController | undefined

/** */
async function getOrCreatePIPController() {
  return import('./PIPController').then(({ PIPController }) => {
    return pipController || (pipController = new PIPController())
  })
}

/** */
export function enterPIP(props: Props) {
  getOrCreatePIPController().then((controller) => controller.mount(props))
}

/** */
export function exitPIP() {
  getOrCreatePIPController().then((controller) => {
    controller.unmount()
    pipController = undefined
  })
}
